/**
 * IbictEmailPrefixPicker - campo do Scaffolder para e-mails IBICT.
 *
 * O usuario digita apenas a parte local do e-mail. O sufixo fixo @ibict.br
 * fica visivel ao lado do campo, e o valor enviado ao template continua sendo
 * apenas o prefixo. O template monta o e-mail completo no backend.
 */

import { FormControl, InputAdornment, TextField } from '@material-ui/core';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import type { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

const EMAIL_SUFFIX = '@ibict.br';

const IbictEmailPrefixPicker = (
  props: FieldExtensionComponentProps<string>,
) => {
  const { onChange, formData, rawErrors, required, schema } = props;
  const preview = formData ? `${formData}${EMAIL_SUFFIX}` : `usuario${EMAIL_SUFFIX}`;

  return (
    <FormControl
      margin="normal"
      required={required}
      error={Boolean(rawErrors?.length)}
      fullWidth
    >
      <TextField
        label={(schema.title as string) ?? 'Email do administrador'}
        value={formData ?? ''}
        onChange={e => onChange(e.target.value)}
        helperText={
          rawErrors?.length
            ? rawErrors.join(', ')
            : `Email final: ${preview}`
        }
        variant="outlined"
        required={required}
        InputLabelProps={{ shrink: Boolean(formData) }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">{EMAIL_SUFFIX}</InputAdornment>
          ),
        }}
      />
    </FormControl>
  );
};

export const IbictEmailPrefixPickerField = createFormField({
  name: 'IbictEmailPrefixPicker',
  component: IbictEmailPrefixPicker,
});

export const ibictEmailPrefixPickerField = FormFieldBlueprint.make({
  name: 'ibict-email-prefix-picker',
  params: {
    field: async () => IbictEmailPrefixPickerField,
  },
});
